import QRCode from 'react-qr-code';
import { Routes, Route, useParams, NavLink } from 'react-router-dom';
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';
import { app, useQuery, getUserTicketQuery } from '../firebase.js';
import { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { collection, getFirestore, getDocs,doc, getDoc, updateDoc } from 'firebase/firestore';
import { LogOut ,SignIn} from '../authentication.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket, faLocationDot, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { useSignInWithGoogle } from "react-firebase-hooks/auth";

export function ViewTicketRoute() {
    const { raveId, ticketId ,ticketType} = useParams();
    return <ViewTicket raveId={raveId} ticketId={ticketId} ticketType={ticketType}/>;
}

function ViewTicket({ raveId, ticketId, ticketType, status }) {
    const isUsed = status === "used";
    return (
        <div
            className="border bg-darkgray-300 p-2 md:p-5 rounded-lg text-center max-w-xs mx-auto my-5"
            style={isUsed ? { opacity: 0.5, pointerEvents: "none", filter: "grayscale(100%)" } : {}}
        >
            <p className="mb-4 font-bold">Tipo: {ticketType}</p>
            <div className="mb-4 border bg-white flex p-3 items-center">
                <QRCode value={`${raveId}/${ticketType}/${ticketId}`} />
            </div>
            <p className="font-bold">Ticket: {raveId}/{ticketType}/{ticketId}</p>
            {isUsed && <p style={{ color: "#f87171", fontWeight: "bold" }}>Código usado</p>}
        </div>
    );
}

export function ConfirmPurchase(){
    const params = new URLSearchParams(window.location.search);
    const checkoutId = params.get('id');

    const [checkoutData, loading, error] = useDocument(doc(getFirestore(), 'checkouts', checkoutId));

    useEffect(() => {
        if (checkoutData && checkoutData.data() && checkoutData.data().status === "completed") {
            window.location.href = "/ticketRaves";
        }
    }, [checkoutData]);

    return (
        <div className="mntrv-container">
            <h1 className="text-white">Confirmación de compra</h1>
            {loading && <p>Cargando...</p>}
            {error && <p>Error al cargar la compra: {error.message}</p>}
            {checkoutData && checkoutData.data() && checkoutData.data().status === "completed" ? (
                <div>
                    <h2 className="text-white">Compra realizada</h2>
                    <p>¡Tu compra fue exitosa!</p>
                </div>
            ) : checkoutData && checkoutData.data() && checkoutData.data().status === "tickets" ? (
                <div>
                    <h2 className="text-white">Generando tickets</h2>
                    <p>Por favor espera mientras se generan tus tickets.</p>
                    <p>Recibirás un correo electrónico con tus tickets una vez que estén listos.</p>
                </div>
            ) : (
                <div>
                    <h2 className="text-white">Procesando compra...</h2>
                    <p>Por favor espera mientras se confirma tu pago.</p>
                </div>
            )}
        </div>
    );
}

function RaveListItem({ raveId, name, date, location, linkLocation }) {
    const { repId } = useParams();

    const [ticketTypes, setTicketTypes] = useState([]);
    const [referral, setReferral] = useState(repId || "");

    useEffect(() => {
        const fetchTicketTypes = async () => {
            try {
                const raveRef = collection(getFirestore(), `raves/${raveId}/ticketTypes`);
                const snapshot = await getDocs(raveRef);
                const tickets = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const visibleTickets = tickets.filter(ticket => !ticket.hidden);
                setTicketTypes(visibleTickets);
            } catch (error) {
                console.error("Error fetching ticket types:", error);
            }
        };

        fetchTicketTypes();
    }, [raveId]);

    const getCheckoutLink = async (ticketType) => {
        const functions = getFunctions(app);
        const createCheckout = httpsCallable(functions, 'createCheckout');

        try {
            const result = await createCheckout({
                ui_mode: "hosted",
                priceId: ticketType.priceId,
                checkoutId: crypto.randomUUID(),
                referral,
                quantity: ticketType.buyQuantity || 1,
            });

            if (!result.data || !result.data.session || !result.data.session.url) {
                console.log(result.data.error);
                if (result.data && result.data.error && result.data.error === "Not enough stock available") {

                    if (result.data.available === 0 || result.data.available < 0) {
                        alert("No hay accesos disponibles de este tipo.");
                        return null;
                    } else if (result.data.available === 1) {
                        alert("Solo queda 1 acceso disponible.");
                    } else if (result.data.available > 1) {
                        alert("Solo quedan " + result.data.available + " accesos disponibles.");
                    }
                    setTicketTypes(prev =>
                        prev.map(type =>
                            type.id === ticketType.id
                                ? { ...type, quantity: result.data.available, buyQuantity: Math.min(result.data.available, type.buyQuantity || 1) }
                                : type
                        )
                    );
                    return null;
                }
            }

            return result.data.session.url;
        } catch (error) {
            console.error("Error creating checkout link:", error);
            return null;
        }
    }

    const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(getAuth(app));
    async function redirectToCheckout(e, ticketType) {
        // Ensure user is authenticated
        if (!getAuth(app).currentUser) {
            const result = await signInWithGoogle();
            if (!result?.user) return;
        }

        // Wait for Stripe customerId to exist in Firestore user doc
        let userDoc;
        do {
            userDoc = await getDoc(doc(getFirestore(), 'users', getAuth(app).currentUser.uid));
            // If userDoc doesn't exist or stripeId is missing, wait and retry
            if (!userDoc.exists() || !userDoc.data().stripeId) {
            await new Promise(resolve => setTimeout(resolve, 500));
            }
        } while (!userDoc.exists() || !userDoc.data().stripeId);

        getCheckoutLink(ticketType).then(link => {
            if (link) {
                window.location.assign(link);
            }
        });
        return Promise.resolve();
    }

    return (
        <div className="mntrv-container" key={raveId}>
            <h2 className="text-white">{name}</h2>
            <>
                <FontAwesomeIcon icon={faLocationDot} />  <span>{location}
                    <iframe title={`Mapa de ${raveId}`} src={linkLocation}  className="w-full h-350px" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe></span><br />
                <FontAwesomeIcon icon={faCalendar} />  <span>{date}</span>

                {ticketTypes.map(ticketType => (
                    <div
                        key={ticketType.id}
                        className="flex items-center bg-black/75 rounded-md p-3 my-3"
                        style={{ minHeight: 56 }}
                    >
                        {/* Column 1: Icon */}
                        <div className="flex items-center justify-center" style={{ width: 36, minWidth: 36 }}>
                            <FontAwesomeIcon icon={faTicket} className="text-gray-400" size="lg" />
                        </div>
                        {/* Column 2: Ticket info */}
                        <div className="flex-1 flex flex-row items-center px-3">

                            {/* Ticket type name and description */}
                            <div className="flex-1 flex flex-col justify-center">
                                <span className="font-semibold">{ticketType.id}</span>
                                <span className="text-sm text-gray-200">{ticketType.description}</span>
                                <span className="font-bold text-lg mt-1">${ticketType.price* (ticketType.buyQuantity || 1)}</span>
                            </div>

                            {/* Column 3: Buy button */}
                            <div className="flex flex-col items-center ml-4">
                                <button
                                    style={{ backgroundColor: "#3B82F6", color: "#fff", border: "none", borderRadius: "4px", padding: "8px 16px", cursor: "pointer" }}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        const originalText = e.target.textContent;
                                        e.target.textContent = "Cargando...";

                                        try {
                                            await redirectToCheckout(e, ticketType);
                                        } finally {
                                            e.target.textContent = originalText;
                                        }
                                    }}
                                >
                                    Comprar
                                </button>
                                <div className="flex items-center">
                                    <button
                                        style={{
                                            backgroundColor: "#1E293B",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            padding: "4px 10px",
                                            marginRight: "8px",
                                            fontSize: "18px",
                                            cursor: "pointer"
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setTicketTypes(prev =>
                                                prev.map(type =>
                                                    type.id === ticketType.id
                                                        ? { ...type, buyQuantity: Math.max(1, (type.buyQuantity || 1) - 1) }
                                                        : type
                                                )
                                            );
                                        }}
                                    >-</button>
                                    <span style={{ minWidth: 24, textAlign: "center", fontWeight: "bold" }}>
                                        {ticketType.buyQuantity || 1}
                                    </span>
                                    <button
                                        style={{
                                            backgroundColor: "#1E293B",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            padding: "4px 10px",
                                            marginLeft: "8px",
                                            fontSize: "18px",
                                            cursor: "pointer"
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setTicketTypes(prev =>
                                                prev.map(type =>
                                                    type.id === ticketType.id
                                                        ? { ...type, buyQuantity: Math.min(type.quantity, (type.buyQuantity || 1) + 1) }
                                                        : type
                                                )
                                            );
                                        }}
                                    >+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/*referral input*/}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8 }}>
                    <p style={{ margin: 0, marginRight: 8 }}>Referencia: </p>
                    <input
                        style={{
                            background: 'transparent',
                            border: 'none',
                            borderBottom: '2px solid #fff',
                            outline: 'none',
                            color: 'white',
                            padding: '4px 4px',
                            marginLeft: '0px',
                            width: '120px',
                            height: '32px',
                            fontSize: '16px',
                            lineHeight: '32px',
                            verticalAlign: 'middle',
                        }}
                        type="text"
                        value={referral}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => setReferral(e.target.value)}
                    />
                </div>
            </>
        </div>
    );
}

export function ViewRaves() {
    const [ravesCollection, loading, error] = useCollection(collection(getFirestore(), "raves"));
    const [raves, setRaves] = useState([]);

    useEffect(() => {

        if (loading || error) { return; }
        const upcomingRaves = ravesCollection.docs.filter(doc => {
            const raveDate = new Date(doc.data().date);
            return new Date(raveDate.getTime() + 24 * 60 * 60 * 1000) > new Date();
        });

        const visibleRaves = upcomingRaves.filter(doc => !doc.data().hidden);
        
        setRaves(visibleRaves);
    }, [ravesCollection, loading, error]);

    if (loading) {
        return <h1 class="text-center">Loading...</h1>;
    }
    if (error) {
        return <p>Error: {error.message}</p>;
    }

    return (
        <div>
            <br></br>
            <h1 className="text-white font-normal md:text-5xl text-3xl p-1">Nuestra siguiente experiencia</h1>
            {raves.map((doc, index) => (
                <RaveListItem key={doc.id} raveId={doc.id} {...doc.data()} isFirst={index === 0} />
            ))}
        </div>
    );
}
export function ViewOwnedTicketRaves() {
    const user = getAuth(app).currentUser;
    const [tickets, setTickets] = useState([]);

    // Always call useEffect, handle user check inside
    useEffect(() => {
        if (!user) {
            setTickets([]);
            return;
        }
        const userId = user.uid;
        const fetchOwnedTickets = async () => {
            try {
                const db = getFirestore();
                const ravesSnapshot = await getDocs(collection(db, "raves"));
                const upcomingRaves = ravesSnapshot.docs.filter(doc => {
                    const raveDate = new Date(doc.data().date); 
                    return new Date(raveDate.getTime() + 24 * 60 * 60 * 1000) > new Date();
                });
                const ownedTickets = [];
                const ticketsPromises = upcomingRaves.map(async (rave) => {
                    try {
                        const ticketTypesSnapshot = await getDocs(collection(getFirestore(), `raves/${rave.id}/ticketTypes`));
                        const ticketTypePromises = ticketTypesSnapshot.docs.map(async (ticketTypeDoc) => {
                            const ticketTypeId = ticketTypeDoc.id;
                            const ticketsQuery = getUserTicketQuery(rave.id, userId, ticketTypeId);
                            const userTickets = await getDocs(ticketsQuery);
                            return userTickets.docs.map(ticket => ({
                                raveId: rave.id,
                                raveName: rave.data().name,
                                raveLocation: rave.data().location,
                                raveDate: rave.data().date,
                                ticketType: ticketTypeDoc.id,
                                ticketId: ticket.id,
                                status: ticket.data().status,
                                redeemed: ticket.data().redeemed
                            }));
                        });
                        const ticketsForRave = await Promise.all(ticketTypePromises);
                        return ticketsForRave.flat();
                    } catch (error) {
                        console.error("Error fetching tickets for rave:", rave.id, error);
                        return [];
                    }
                });

                const allTickets = await Promise.all(ticketsPromises);
                ownedTickets.push(...allTickets.flat());

                setTickets(ownedTickets);
            } catch (error) {
                console.error("Error fetching owned tickets:", error);
            }
        };

        fetchOwnedTickets();
    }, [user]);

    if (!user) {
        return <SignIn />;
    }
    const userId = user.uid;

    const ticketsByRave = tickets.reduce((acc, ticket) => {
        if (!acc[ticket.raveId]) {
            acc[ticket.raveId] = {
                raveName: ticket.raveName,
                raveLocation: ticket.raveLocation,
                raveDate: ticket.raveDate,
                tickets: []
            };
        }
        acc[ticket.raveId].tickets.push(ticket);
        return acc;
    }, {});

    return (
        <div>
            <br></br>
            <h1 className="text-white">Tus Códigos</h1>
            {Object.keys(ticketsByRave).length > 0 ? (
                Object.entries(ticketsByRave).map(([raveId, { raveName, raveLocation, raveDate, tickets }]) => (
                    <div className="mntrv-container" key={raveId}>
                        <h1 className="text-white">{raveName}</h1>
                        <FontAwesomeIcon icon={faLocationDot} />  <span>{raveLocation}</span> <br />
                        <FontAwesomeIcon icon={faCalendar} />  <span>{raveDate}</span>
                        {tickets.map(ticket => (
                            <div key={ticket.ticketId}>
                                <ViewTicket
                                    raveId={ticket.raveId}
                                    ticketId={ticket.ticketId}
                                    ticketType={ticket.ticketType}
                                    status={ticket.status}
                                    redeemed={ticket.redeemed}
                                />
                                <hr></hr>
                            </div>
                        ))}
                    </div>
                ))
            ) : (
                <p>Visita la pantalla de compra para conseguir tus códigos!</p>
            )}
        </div>
    );
}


export function RoleChange({ role }) {
    const { raveId, role_key } = useParams();

    const handleRoleChange = async () => {
        const functions = getFunctions(app);
        const changeRole = httpsCallable(functions, 'changeRoleLink');
        await changeRole({ raveId, role, role_key });
    };
    handleRoleChange().then(() => {
        window.location.href = "/" + role;
    });
    return (
        <div className="mntrv-container">
            <h1 className="text-white">Cambiando rol...</h1>
            <p>Redirigiendo...</p>
        </div>
    );
}
export function Home() {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const imageUrl = "https://firebasestorage.googleapis.com/v0/b/monterrave-1f76f.firebasestorage.app/o/ImagenesGlobal%2FLogoTransparente2.png?alt=media";


    useEffect(() => {
        const fetchAnnouncements = async () => {
            try {
                const db = getFirestore();
                let ownedRaveIds = new Set();

                // Try to get user id, but allow null
                let userId = null;
                try {
                    userId = getAuth(app).currentUser?.uid || null;
                } catch {
                    userId = null;
                }

                // If user is logged in, fetch owned raves
                if (userId) {
                    const ravesSnapshot = await getDocs(collection(db, "raves"));
                    const upcomingRaves = ravesSnapshot.docs.filter(doc => {
                        const raveDate = new Date(doc.data().date);
                        return raveDate > new Date();
                    });

                    const ticketsPromises = upcomingRaves.map(async (rave) => {
                        const ticketTypesSnapshot = await getDocs(collection(db, `raves/${rave.id}/ticketTypes`));
                        const ticketTypePromises = ticketTypesSnapshot.docs.map(async (ticketTypeDoc) => {
                            const ticketsQuery = getUserTicketQuery(rave.id, userId, ticketTypeDoc.id);
                            const userTickets = await getDocs(ticketsQuery);
                            if (userTickets.docs.length > 0) {
                                ownedRaveIds.add(rave.id);
                            }
                        });
                        await Promise.all(ticketTypePromises);
                    });
                    await Promise.all(ticketsPromises);
                }

                const snapshot = await getDocs(collection(db, "announcements"));
                const items = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // If not logged in, only show Global announcements
                const filtered = items.filter(a =>
                    a.rave && (a.rave === "Global" || (userId && ownedRaveIds.has(a.rave)))
                );

                filtered.sort((a, b) => {
                    return b.created.toDate() - a.created.toDate();
                });

                // Fetch photo URLs for each announcement
                const withPhotos = await Promise.all(filtered.map(async (a) => {
                    try {
                        const { getStorage, ref, getDownloadURL } = await import('firebase/storage');
                        const storage = getStorage();
                        const imgRef = ref(storage, `Anuncios/${a.id}`);
                        const url = await getDownloadURL(imgRef);
                        return { ...a, photoURL: url };
                    } catch {
                        return { ...a, photoURL: null };
                    }
                }));

                setAnnouncements(withPhotos);
            } catch (err) {
                setError('Error loading announcements');
                console.log(err);
            } finally {
                setLoading(false);
            }
        };
        fetchAnnouncements();
    }, []);

    return (
        <div className="mb-20">
            <div
                className="mntrv-container"
                style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                }}
            >
                <h1 className="text-white">MONTERAVE</h1>
                <p>COMUNIDAD UNDERGROUND EN MONTERREY </p>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <h4 className="text-white" style={{ margin: 0 }}>
                    FIESTAS
                    </h4>
                    <div
                    style={{
                        width: "2px",
                        height: "1.5em",
                        background: "#fff",
                        margin: "0 12px",
                    }}
                    />
                        <h4 className="text-white" style={{ margin: 0 }}>
                        RAVES
                        </h4>
                    <div
                    style={{
                        width: "2px",
                        height: "1.5em",
                        background: "#fff",
                        margin: "0 12px",
                    }}
                    />
                    <h4 className="text-white" style={{ margin: 0 }}>
                    MORE...
                    </h4>
                    <br />
                    <br />
                </div>
                <p>GOOD VIBES ONLY</p>
                <img
                    src={imageUrl}
                    alt="Logo"
                    style={{ width: "110px", height: "110px" }}
                />
                
            </div>
            <h1 className="text-white">Anuncios</h1>
            {loading && <p>Cargando anuncios...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && announcements.length === 0 && <p>No hay anuncios.</p>}
            {!loading && !error && announcements.map(a => (
                <div key={a.id} className="mntrv-container">
                    <h3>{a.title}</h3>
                    <div dangerouslySetInnerHTML={{ __html: a.content }}></div>
                    {a.photoURL && (
                        <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center' }}>
                            <img
                                src={a.photoURL}
                                alt="Anuncio"
                                style={{
                                    maxWidth: '350px',
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 8,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                }}
                            />
                        </div>
                    )}
                    <div style={{ textAlign: 'right' }}>
                        <small>
                            {a.created.toDate().toLocaleString()}
                        </small>
                    </div>
                </div>
            ))}
        </div>
    );
}
export function Profile() {
    const [displayName, setDisplayName] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [photoURL, setPhotoURL] = useState(null);
    const [uploading, setUploading] = useState(false);

    const user = getAuth(app).currentUser;

    useEffect(() => {
        if (!user) {
            setLoading(false);
            return;
        }
        const fetchProfile = async () => {
            setLoading(true);
            try {
                const db = getFirestore();
                const userDoc = await getDoc(doc(db, 'users', user.uid));
                if (userDoc.exists()) {
                    setDisplayName(userDoc.data().displayName || '');
                }
                // Try to get photo URL from storage
                const { getStorage, ref, getDownloadURL } = await import('firebase/storage');
                const storage = getStorage();
                const imgRef = ref(storage, `ImagenesRP/${user.uid}`);
                try {
                    const url = await getDownloadURL(imgRef);
                    setPhotoURL(url);
                } catch {
                    setPhotoURL(null);
                }
            } catch (err) {
                setError('Error fetching profile');
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [user]);

    if (!user) {
        return <SignIn />;
    }

    const handleSave = async () => {
        if (!user) return;
        setSaving(true);
        setError(null);
        try {
            const db = getFirestore();
            await updateDoc(doc(db, 'users', user.uid), { displayName });
        } catch (err) {
            setError('Error saving display name');
        } finally {
            setSaving(false);
        }
    };

    const handlePhotoUpload = async (e) => {
        if (!user || !e.target.files[0]) return;
        setUploading(true);
        setError(null);
        try {
            const { getStorage, ref, uploadBytes, getDownloadURL } = await import('firebase/storage');
            const storage = getStorage();
            const file = e.target.files[0];
            const imgRef = ref(storage, `ImagenesRP/${user.uid}`);
            await uploadBytes(imgRef, file);
            const url = await getDownloadURL(imgRef);
            setPhotoURL(url);
        } catch (err) {
            console.log(err);
            setError('Error uploading photo');
        } finally {
            setUploading(false);
        }
    };

    return (
        <>  
            <br />
            <h1 className="text-white">Tu Perfil</h1>
            <div className="mntrv-container">
                <div className="mntrv-container" style={{ textAlign: 'center', paddingBottom: '0.25px' }}>
                    <p >Hola {displayName || user?.email || 'usuario'}.</p>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <h3 className="text-white">Subir foto de perfil</h3>
                        <label style={{ cursor: 'pointer', display: 'inline-block' }}>
                            {photoURL ? (
                                <img
                                    src={photoURL}
                                    alt="Foto de perfil"
                                    style={{ width: 120, height: 120, borderRadius: '50%', objectFit: 'cover', marginBottom: 10, border: '2px solid #3B82F6' }}
                                />
                            ) : (
                                <div style={{
                                    width: 120,
                                    height: 120,
                                    borderRadius: '50%',
                                    background: '#ccc',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: 10,
                                    border: '2px solid #3B82F6'
                                }}>
                                    <span>Subir foto</span>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handlePhotoUpload}
                                disabled={uploading}
                                style={{ display: 'none' }}
                            />
                        </label>
                        {uploading && <p>Subiendo foto...</p>}
                    </div>
                    <div><hr />
                        <h3 className="text-white">Cambio de nombre</h3>
                        
                        <input
                            style={{
                                background: 'transparent',
                                border: 'none',
                                borderBottom: '2px solid #fff',
                                outline: 'none',
                                color: 'white',
                                padding: '4px 4px',
                                marginLeft: '0px',
                                width: '300px',
                                height: '32px',
                                fontSize: '16px',
                                lineHeight: '32px',
                                verticalAlign: 'middle',
                            }}
                            type="text"
                            value={displayName}
                            onChange={e => setDisplayName(e.target.value)}
                        /><hr />
                        <button 
                            style={{ backgroundColor: "#3B82F6", color: "#fff", border: "none", borderRadius: "4px", padding: "8px 16px", cursor: "pointer" }}
                            onClick={handleSave} disabled={saving}>
                            {saving ? 'Guardando...' : 'Guardar'}
                        </button>
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                    </div>
                </div>
                <LogOut />
                <br />
            </div>
        </>
    );
}

export default function User() {
    return (
        <>
        
            <h1 className='title'>Monterave</h1>
            
        </>
    );
}



/*
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';

import { loadStripe } from '@stripe/stripe-js';
const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
function BuyScreen({ priceId }) {
    const [client_secret, setClientSecret] = useState(null);

    useEffect(() => {
        const functions = getFunctions(app);
        const createCheckout = httpsCallable(functions, 'createCheckout');

        createCheckout({
            ui_mode: "embedded",
            priceId: priceId,
            checkoutId: crypto.randomUUID(),
            success_url: window.location.href,
        }).then((result) => {
            if (result.data && result.data.session) {
                setClientSecret(result.data.session.client_secret);
            } else {
                console.error("Error: session or client_secret is undefined in the response.", result.data);
            }
        });

    }, [priceId]);

    return (
        <>
            <h1>BuyScreen</h1>
            {stripe && client_secret ? (
                <EmbeddedCheckoutProvider stripe={stripe} options={{ clientSecret: client_secret }}>
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            ) : (
                <p>Loading...</p>
            )}
        </>
    );
}
*/